/* eslint-disable max-len */
import React from 'react';

export const UnexpectedErrorThreeSVG = () => (
  <svg
    width="240"
    height="250"
    viewBox="0 0 240 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="47"
      y="12"
      width="79"
      height="188"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47 12.45H125.799V199.225H47V12.45Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M118.921 180.686L59.4993 198.799C53.2773 200.696 47 196.014 47 189.477V22.1979C47 15.6123 53.3642 10.9246 59.6094 12.9102L119.031 31.8018C123.06 33.083 125.799 36.8413 125.799 41.0898V171.364C125.799 175.655 123.006 179.441 118.921 180.686Z"
        fill="black"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M96.687 34.514C96.687 36.0312 95.8471 37.261 94.8113 37.261C93.7754 37.261 92.9355 36.0312 92.9355 34.514C92.9355 32.9969 93.7754 31.7671 94.8113 31.7671C95.8471 31.7671 96.687 32.9969 96.687 34.514Z"
      fill="#697079"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M100.631 35.82C100.631 36.7644 100.108 37.5302 99.4629 37.5302C98.8178 37.5302 98.2949 36.7644 98.2949 35.82C98.2949 34.8756 98.8178 34.1099 99.4629 34.1099C100.108 34.1099 100.631 34.8756 100.631 35.82Z"
      fill="#697079"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6904 34.6487V173.935L124.727 158.313V50.9424L55.6904 34.6487Z"
      fill="#774331"
    />
    <mask
      id="mask1_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M104.25 171.629H119.739L124.943 146.539H104.25V171.629Z"
        fill="#0383A4"
      />
    </g>
    <mask
      id="mask2_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M98.7988 174.719H114.288L119.491 149.629H98.7988V174.719Z"
        fill="#B1E1F4"
      />
    </g>
    <mask
      id="mask3_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.4473 86.4256H94.9361L94.8333 61.3357H79.4473V86.4256Z"
        fill="#0383A4"
      />
    </g>
    <mask
      id="mask4_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask4_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M90.8486 87.5044H106.337L106.28 62.4146H90.8486V87.5044Z"
        fill="#9870B1"
      />
    </g>
    <mask
      id="mask5_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask5_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.5635 86.3386H88.0523L87.9542 61.2488H72.5635V86.3386Z"
        fill="#10BEF0"
      />
    </g>
    <mask
      id="mask6_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask6_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.5166 82.3582L76.0055 84.4443V57.2683H60.5166V82.3582Z"
        fill="#B1E1F4"
      />
    </g>
    <mask
      id="mask7_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="55"
      y="34"
      width="70"
      height="140"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 173.935L124.727 158.313V50.9424L55.6904 34.6487V173.935Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask7_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.8008 79.1826H57.2896V54.0928H41.8008V79.1826Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.982 117.874H122.471L122.261 92.7842H106.982V117.874Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M92.5693 117.518H108.058L107.937 92.4277H92.5693V117.518Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M84.3945 116.406H99.8834L99.5571 91.3157H84.3945V116.406Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.0928 118.97H95.5816L91.1212 93.8806H80.0928V118.97Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.5283 116.98H79.0172L78.5504 91.8906H63.5283V116.98Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.0391 115.061H63.5279L63.34 89.9712H48.0391V115.061Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.2432 116.414H60.732L60.4057 91.3237H45.2432V116.414Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.971 147.768L119.46 143.854L124.663 122.678H103.971V147.768Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.124 146.066H115.613L120.817 120.976H100.124V146.066Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.5938 146.791H111.083L116.286 121.701H95.5938V146.791Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.3311 147.913H106.82L112.024 122.823H91.3311V147.913Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.1504 146.883H102.639L107.843 121.793H87.1504V146.883Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.2676 148.018H94.7564L99.9601 122.928H79.2676V148.018Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M77.0107 149.457H92.4996L97.7033 124.367H77.0107V149.457Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.3691 147.156H87.858L93.0617 122.066H72.3691V147.156Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.8701 149.106H84.359L89.5627 124.016H68.8701V149.106Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.124 151.81H75.6129L80.8166 126.72H60.124V151.81Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M53.3428 149.651H68.8316L74.0353 124.562H53.3428V149.651Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M46.9639 149.604H62.4527L67.6564 124.514H46.9639V149.604Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M41.6377 152.542H57.1266L62.3302 127.452H41.6377V152.542Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M95.9121 172.217H111.401L116.605 147.127H95.9121V172.217Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.5879 176.001H101.077L106.28 150.911H85.5879V176.001Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.207 178.659H95.6959L100.9 153.569H80.207V178.659Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.1406 176.093H89.6295L94.8332 151.003H74.1406V176.093Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.2617 179.653H82.7506L87.9543 154.563H67.2617V179.653Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.7461 179.662H74.235L79.4386 154.572H58.7461V179.662Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.2871 184.597H70.776L75.9796 159.507H55.2871V184.597Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M50.6504 182.161H66.1392L71.3429 157.071H50.6504V182.161Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M48.4941 183.636H63.983L69.1867 158.546H48.4941V183.636Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.7822 182.845H56.2711L61.4748 157.756H40.7822V182.845Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.5625 182.708H52.0514L57.255 157.618H36.5625V182.708Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M97.7031 147.098V123.069L99.9606 122.928V146.869L97.7031 147.098Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.286 121.259V145.181L120.817 144.478V120.976L116.286 121.259Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.727 122.678L120.816 122.923V143.612L124.727 143.005V122.678Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M112.023 121.958V144.979L116.285 144.338V121.7L112.023 121.958Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M105.585 145.963V121.934L107.842 121.793V145.734L105.585 145.963Z"
        fill="#EF5489"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.96 122.279V146.853L107.842 145.645V121.794L99.96 122.279Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.843 123.085V145.628L112.024 144.979V122.823L107.843 123.085Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M93.0615 124.657V147.924L97.7027 147.203V124.367L93.0615 124.657Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.0352 127.144V150.88L80.8166 149.827V126.72L74.0352 127.144Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M80.8164 124.557V149.827L89.5631 148.482V124.016L80.8164 124.557Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.5635 122.28V148.468L93.0622 147.936V122.066L89.5635 122.28Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M67.6562 124.947V151.871L74.0351 150.913V124.562L67.6562 124.947Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.6904 153.738L62.3307 152.721V127.452L55.6904 127.861V153.738Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.3311 124.847V152.699L67.6566 151.871V124.514L62.3311 124.847Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120.817 60.9547L124.942 61.7017V50.5098L120.58 49.531L120.817 60.9547Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M115.258 48.2749L115.373 59.9323L120.817 60.9547V49.5868L115.258 48.2749Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M111.761 47.4497L112.024 59.2754L116.144 60.0625V48.4843L111.761 47.4497Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.443 46.4307L107.628 58.4183L112.023 59.2753V47.5117L107.443 46.4307Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.6738 44.5967L99.9608 56.971L107.735 58.4559V46.4992L99.6738 44.5967Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M96.9668 43.958L97.7029 56.5401L99.9604 56.9712V44.6646L96.9668 43.958Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.2119 42.5996L91.7093 55.39L97.703 56.5396V44.1315L91.2119 42.5996Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.749 41.7825L88.482 54.7412L92.9892 55.6395V43.0192L87.749 41.7825Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.4814 39.5952L80.0923 53.2272L89.4728 54.9678V42.1893L78.4814 39.5952Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.1084 37.855L72.5634 51.7132L80.8167 53.3147V40.1464L71.1084 37.855Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M64.3867 36.2686L66.7548 50.6319L73.823 51.9789V38.4957L64.3867 36.2686Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M59.2988 35.0676L60.3014 49.3338L67.6566 50.8008V37.04L59.2988 35.0676Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.1866 49.7562V35.7494L55.4756 33.9998V48.2992L62.1866 49.7562Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.4756 174.368L57.256 174.014V157.619L55.4756 157.896V174.368Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.4746 173.059L69.1869 171.329V158.546L61.4746 159.9V173.059Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.2559 174.014L61.4751 173.083V157.755L57.2559 158.484V174.014Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M71.3428 170.826L75.9793 169.793V159.507L71.3428 160.316V170.826Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M69.1865 171.314L71.3424 170.826V157.071L69.1865 157.453V171.314Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.9541 167.067L94.8334 165.558V151.003L87.9541 152.184V167.067Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.4385 168.994L87.9539 167.067V154.563L79.4385 156.07V168.994Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.9795 169.777L79.4389 169.014V154.572L75.9795 155.169V169.777Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.833 165.51L100.899 164.138V153.569L94.833 154.643V165.51Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.28 162.92L116.605 160.603V147.127L106.28 148.94V162.92Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.899 164.138L106.28 162.952V150.911L100.899 151.839V164.138Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.942 158.746V146.539L119.491 147.466V159.93L124.942 158.746Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.605 160.584L119.492 159.931V149.629L116.605 150.14V160.584Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M124.942 68.5758L119.491 67.6865V87.817L124.942 88.2159V68.5758Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M116.605 65.0334V87.5969L119.492 87.8169V65.5235L116.605 65.0334Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M106.28 62.4146V86.8098L116.605 87.5903V64.1535L106.28 62.4146Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.899 63.0149V86.3999L106.28 86.7994V63.9047L100.899 63.0149Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M94.833 61.3357V85.9377L100.899 86.3999V62.3659L94.833 61.3357Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.9541 61.2488V85.4134L94.8334 85.9219V62.3818L87.9541 61.2488Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.4385 60.8838V84.7642L87.9539 85.4131V62.3301L79.4385 60.8838Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.9795 57.2683V84.5007L79.4389 84.7576V57.8408L75.9795 57.2683Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M61.4746 55.6699V83.3952L69.1869 83.978V56.9687L61.4746 55.6699Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.2559 54.0881V83.0736L61.4751 83.387V54.7865L57.2559 54.0881Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.4756 82.9542L57.256 83.0736V55.6021L55.4756 55.3364V82.9542Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.245 93.0035L122.262 92.7842V115.884L126.245 115.72V93.0035Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M117.68 95.3435V116.073L122.262 115.884V95.596L117.68 95.3435Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M110.129 93.1973V116.385L117.679 116.073V93.6131L110.129 93.1973Z"
        fill="#E565C4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.937 92.4277V116.475L110.129 116.387V92.5449L107.937 92.4277Z"
        fill="#B1E1F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.057 93.6731V116.676L107.937 116.475V93.9419L103.057 93.6731Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M99.5273 116.822L103.057 116.677V91.5103L99.5273 91.3157V116.822Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M91.1211 93.8806V117.169L99.5053 116.823V94.3425L91.1211 93.8806Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M78.5498 91.8904V117.687L84.5354 117.44V92.22L78.5498 91.8904Z"
        fill="#9870B1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M73.4473 92.9072V117.897L78.55 117.687V93.1883L73.4473 92.9072Z"
        fill="#10BEF0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.3398 89.9712V118.314L73.4471 117.9V90.5242L63.3398 89.9712Z"
        fill="#0E9D97"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.4053 91.3237V118.435L63.2545 118.318V91.4807L60.4053 91.3237Z"
        fill="#47C2BB"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.4053 91.3237V118.435L63.2545 118.318V91.4807L60.4053 91.3237Z"
        fill="#0383A4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M60.4057 92.1888L54.2783 91.8513V118.688L60.4057 118.435V92.1888Z"
        fill="#B1E1F4"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6895 156.628L124.726 144.899V141.51L55.6895 152.235V156.628Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M124.726 87.509L55.6895 82.2332V86.5151L124.726 90.8121V87.509Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M124.726 114.923L55.6895 117.77V122.025L124.726 118.206V114.923Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.6895 51.8716L124.726 64.0873V60.757L55.6895 47.5542V51.8716Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M165.195 241.939L157.329 245.969C156.937 246.155 156.686 246.558 156.686 247.002V247.59H181.281L177.689 191.621L179.777 147.137C180.047 141.378 175.503 136.546 169.769 136.497L150.961 136.335C145.343 136.287 140.765 140.854 140.768 146.502L140.795 191.537L140.795 192.011L140.816 192.201L145.311 232.75C145.301 236.692 143.069 240.282 139.571 241.939L131.705 245.969C131.313 246.155 131.062 246.558 131.062 247.002V247.59H155.657L154.256 225.757L154.246 191.621L155.734 164.315H164.873L164.891 191.537L164.892 192.011L164.913 192.201L170.16 225.759L170.935 232.75C170.925 236.692 168.693 240.282 165.195 241.939Z"
      fill="#0082A5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M167.191 81.3169L166.552 69.7578H157.291L156.653 83.491C148.509 86.6422 147.419 89.9256 147.419 96.2902L177.733 94.0571C177.733 87.6928 176.908 82.421 167.191 81.3169Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M148.252 49.7212C146.063 52.9121 148.694 59.3551 153.684 59.8696C158.674 60.3841 157.389 53.6388 157.389 53.6388L148.252 49.7212Z"
      fill="#5E3A30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.039 54.2198C155.766 53.6762 153.129 56.7262 151.476 62.3464C151.225 63.0445 149.991 66.596 150.282 67.3703C150.574 68.1436 151.581 68.6484 152.423 68.7633C152.656 73.8318 152.954 76.4308 157.401 77.0117C161.744 77.5795 166.523 73.5366 167.348 65.4505C168.011 58.9452 166.698 54.8033 161.039 54.2198Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M162.767 62.139C163.26 59.3003 160.469 56.7645 156.829 56.3891C155.262 56.2277 153.966 56.0413 153.966 56.0413C147.891 55.415 148.252 49.7215 148.252 49.7215C149.537 47.87 152.419 49.7099 152.419 49.7099C152.419 49.7099 152.282 47.8221 153.801 47.9787C159.279 50.266 163.635 49.8051 167.171 50.9563C169.2 51.6165 170.512 53.5926 170.41 55.7339C170.25 59.0728 170.18 64.4664 167.604 70.6052C167.286 71.3625 166.983 71.9321 166.696 72.3398C166.039 67.2212 161.241 72.4839 162.767 62.139Z"
      fill="#5E3A30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M193 115.422C193 115.016 192.971 114.603 192.922 114.19C192.922 114.188 192.924 114.185 192.924 114.184C192.796 113.119 192.514 112.052 192.129 111.092C189.558 104.464 183.957 90.3173 182.372 88.6732C179.578 84.8923 173.955 82.0852 167.192 81.3169L156.579 88.4332L156.653 82.8331C150.239 84.6169 145.713 87.6671 143.149 91.2153C142.964 91.4058 142.787 91.6082 142.622 91.8253C136.746 99.5649 131.653 103.818 127.894 104.125C124.458 104.408 120.426 101.278 115.851 97.0717C110.814 98.0841 108.35 98.9808 107.155 103.182C110.414 111.172 118.999 117.303 127.369 117.303C127.89 117.303 128.418 117.282 128.953 117.238C132.867 116.919 136.723 116.602 140.659 114.988V151.642H179.915C179.915 145.013 180.029 134.879 180.22 129.683C181.288 129.212 182.353 128.732 183.419 128.239C187.026 126.516 189.85 124.029 191.471 121.119C191.472 121.12 191.473 121.12 191.473 121.121C192.459 119.353 193 117.428 193 115.422Z"
      fill="#F15961"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.851 97.0718C110.814 98.0841 108.35 98.9809 107.155 103.182C107.785 104.727 108.616 106.2 109.604 107.575C111.006 103.854 114.642 101.022 119.195 100.001C118.115 99.1169 117 98.1283 115.851 97.0718Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M115.85 97.0717C114.72 96.0324 113.557 94.9285 112.361 93.793C111.548 93.0213 110.721 92.2358 109.876 91.444C107.233 88.9662 103.093 89.1122 100.629 91.7692C98.1642 94.4263 98.3092 98.5889 100.952 101.066C101.776 101.839 102.584 102.606 103.377 103.359C104.134 104.078 104.888 104.793 105.64 105.499C106.835 101.297 110.813 98.0841 115.85 97.0717Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M166.911 124.452C165.165 124.879 161.459 126.206 161.459 126.206L165.054 135.604C165.516 135.444 170.556 133.745 171.017 133.582C171.04 133.319 171.055 133.053 171.055 132.784C171.055 129.344 169.84 126.098 166.911 124.452Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.585 126.223C159.839 126.65 158.674 126.835 158.674 126.835C158.674 126.835 156.127 126.418 154.199 128.285C153.476 128.997 153.161 129.793 153.306 130.441C150.656 132.313 153.118 141.581 161.913 136.822C162.496 136.645 163.079 136.405 163.648 136.096L163.643 136.087L165.054 135.604C165.516 135.444 165.976 135.28 166.437 135.117C166.46 134.854 166.475 134.588 166.475 134.32C166.475 130.879 164.513 127.87 161.585 126.223Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M174.084 81.8698C173.839 80.7217 172.88 79.8676 171.716 79.7629L170.416 79.6458C170.153 78.41 169.067 77.5273 167.81 77.5273H167.014L156.798 88.2047V80.3777C154.099 80.8164 153.555 83.8469 153.555 83.8469L156.798 88.8423C156.798 88.8423 169.529 81.2547 174.327 83.009L174.084 81.8698Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.459 104.827C161.278 104.827 161.132 104.68 161.132 104.498V85.6405C161.132 85.4588 161.278 85.3115 161.459 85.3115C161.64 85.3115 161.786 85.4588 161.786 85.6405V104.498C161.786 104.68 161.64 104.827 161.459 104.827Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M155.462 98.3582C155.281 98.3582 155.135 98.2109 155.135 98.0292V85.7498C155.135 85.5684 155.281 85.4211 155.462 85.4211C155.643 85.4211 155.789 85.5684 155.789 85.7498V98.0292C155.789 98.2109 155.643 98.3582 155.462 98.3582Z"
      fill="#FFCC66"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M140.658 144.187V151.642H179.914C179.914 149.441 179.927 146.852 179.951 144.187H140.658Z"
      fill="#F6915A"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M170.934 232.75C170.924 236.692 168.692 240.283 165.194 241.939L157.329 245.97C156.937 246.155 156.686 246.558 156.686 247.002V247.59H181.28L180.309 232.46H170.902L170.934 232.75Z"
      fill="#5E3A30"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.686 232.46H145.279L145.311 232.75C145.301 236.692 143.069 240.283 139.571 241.939L131.706 245.97C131.314 246.155 131.062 246.558 131.062 247.002V247.59H155.657L154.686 232.46Z"
      fill="#5E3A30"
    />
    <mask
      id="mask8_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="131"
      y="247"
      width="25"
      height="2"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M131.062 247.246H155.76V249H131.062V247.246Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask8_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M155.646 247.246H131.062V249H155.76L155.646 247.246Z"
        fill="#B26E4B"
      />
    </g>
    <mask
      id="mask9_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="156"
      y="247"
      width="26"
      height="2"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M156.661 247.246H181.359V249H156.661V247.246Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask9_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M181.245 247.246H156.661V249H181.359L181.245 247.246Z"
        fill="#B26E4B"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M180.316 232.554H175.241C173.052 234.488 174.386 236.94 176.289 236.94H180.598L180.316 232.554Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.692 232.554H148.634C146.444 234.488 147.778 236.94 149.682 236.94H154.973L154.692 232.554Z"
      fill="#B26E4B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M179.997 225.757H170.183L170.902 232.46H180.31L179.997 225.757Z"
      fill="#1B566B"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M154.262 225.757H144.448L145.279 232.46H154.686L154.262 225.757Z"
      fill="#1B566B"
    />
    <mask
      id="mask10_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="85"
      y="80"
      width="35"
      height="47"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.0527 80.9683V126.153L119.804 126.595V80.3777L85.0527 80.9683Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask10_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M89.8369 115.023L105.411 118.751L109.829 92.7524L94.1986 88.3667L89.8369 115.023Z"
        fill="#C6DBE0"
      />
    </g>
    <mask
      id="mask11_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="85"
      y="80"
      width="35"
      height="47"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.0527 80.9683V126.153L119.804 126.595V80.3777L85.0527 80.9683Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask11_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M87.9629 88.491L101.921 114.804L109.61 93.1909L93.9799 88.8055L87.9629 88.491Z"
        fill="#F4F8FA"
      />
    </g>
    <mask
      id="mask12_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="85"
      y="80"
      width="35"
      height="47"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.0527 80.9683V126.153L119.804 126.595V80.3777L85.0527 80.9683Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask12_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M83.1641 114.804L98.8664 119.189L103.156 92.5331L87.5257 88.1475L83.1641 114.804Z"
        fill="#C6DBE0"
      />
    </g>
    <mask
      id="mask13_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="85"
      y="80"
      width="35"
      height="47"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.0527 80.9683V126.153L119.804 126.595V80.3777L85.0527 80.9683Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask13_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M103.156 92.533L98.7939 119.197L105.467 118.922L109.829 92.9005L103.156 92.533Z"
        fill="#D8E5E9"
      />
    </g>
    <mask
      id="mask14_1414_6181"
      style={{ maskType: 'luminance' }}
      maskUnits="userSpaceOnUse"
      x="85"
      y="80"
      width="35"
      height="47"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M85.0527 80.9683V126.153L119.804 126.595V80.3777L85.0527 80.9683Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask14_1414_6181)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M109.99 94.4113L109.729 94.3643C106.719 93.0956 105.456 95.0571 106.719 96.8233L108.9 100.332L111.665 96.2553L109.99 94.4113Z"
        fill="#B26E4B"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M90.036 108.328C90.1266 107.886 90.3598 107.556 90.7356 107.339C91.1117 107.121 91.5374 107.061 92.0127 107.16C92.4879 107.258 92.8553 107.482 93.1155 107.832C93.3745 108.181 93.4593 108.577 93.3689 109.019C93.2782 109.461 93.0445 109.791 92.669 110.009C92.2925 110.227 91.8671 110.286 91.3919 110.188C90.9166 110.089 90.5489 109.865 90.2893 109.516C90.0297 109.166 89.9453 108.771 90.036 108.328ZM90.9596 105.68C91.1385 104.808 91.3776 104.14 91.677 103.676C91.9768 103.212 92.3841 102.84 92.8999 102.561C93.4153 102.282 93.8189 102.012 94.1106 101.752C94.4023 101.492 94.5865 101.176 94.6622 100.806C94.8473 99.9043 94.5534 99.3732 93.7812 99.2131C93.4247 99.1394 93.1096 99.2109 92.836 99.4283C92.5624 99.6455 92.3735 99.977 92.2698 100.423L89.2578 99.7984C89.5146 98.6061 90.0796 97.7533 90.9528 97.24C91.826 96.7265 92.9279 96.6077 94.2586 96.8838C95.5837 97.1582 96.5466 97.6784 97.1481 98.4445C97.7499 99.2106 97.9347 100.161 97.7019 101.296C97.6003 101.792 97.4099 102.222 97.1303 102.588C96.8511 102.954 96.4513 103.303 95.9305 103.638L94.7092 104.384C94.3605 104.604 94.0994 104.851 93.9261 105.123C93.7525 105.395 93.6132 105.757 93.5082 106.208L90.9596 105.68Z"
      fill="#1B566B"
    />
  </svg>
);
